const FORMAT_SELLER_BUYER_NAME: Record<string, string> = {
  "Partner A": "Partner",
  "Partner B": "Partner",
};

export const formatDealTypeSellerAndBuyerName = (savedName: string) => {
  return FORMAT_SELLER_BUYER_NAME[savedName] || savedName;
};
